import { useTheme } from '@emotion/react';
import { Box, Grid } from '@material-ui/core';
import { CircularProgress, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { message } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import OwnTestCreationCard from '../Card/OwnTestCreationCard';
import TestSeriesCardSubscribed from '../Card/TestSeriesCard';
import { configUrl } from '../config';
import { LoginContext } from '../contexts/LoginContext';
import TestSeriesCardUnsubscribed from '../SplashScreens/TestSeriesCard';
import TestSeriesDetails from '../SplashScreens/TestSeriesDetails';
import cardTemplateDescriptions from '../staticDataTemplate.json';
import styles from '../styles/TestSeries.module.css';
import useGetAssignedCoursesById from '../testSeriesHooks/useGetAssignedCoursesById';
import GridContainer from './Grid/GridContainer';
import GridItem from './Grid/GridItem';
import MedineerLogin from './MedineerComponents/MedineerLogin';
export default function TestSeries(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const { testSeriesStatus, isDrawerNavigation, providerId, trailCourseData } = React.useContext(LoginContext);
  const [isSubscribed, setIsSubscribed] = React.useState(isDrawerNavigation === true ? false : true);
  const [loadingState, setLoadingState] = React.useState(false);
  const [selectedSeries, setSelectedSeries] = React.useState(null);
  const [courseDetails, setCourseDetails] = React.useState();
  const [showCheckout, setShowCheckout] = React.useState(false);

  console.log("assess", isDrawerNavigation);
  const { isLoading, error, data: courses, refetch } = useGetAssignedCoursesById(isSubscribed);

  const [course, setCourses] = React.useState([]);

  React.useEffect(() => {
    if (isSubscribed != null) {
      setLoadingState(true); // Set loadingState to true when toggle happens
      refetch().finally(() => setLoadingState(false));
    }
  }, [isSubscribed]);
  const handleToggle = (event, newSubscription) => {
    if (newSubscription !== null) {
      setIsSubscribed(newSubscription === "subscribe");
    }
  };

  const handleLearnMore = (series) => {
    //navigate('/medineer/test-series-details', { state: { series } });
    //setSelectedSeries(series);
  };
  const onEnroll = (series) => {
    if (series?.assingnedStudentsCount && series?.testSeriesStudentsCount && series?.testSeriesStudentsCount > 0 && (series?.assingnedStudentsCount + 1) > series?.testSeriesStudentsCount) {
      message.error("Please contact the admin.");
    } else {
      setCourseDetails(series);
      setShowCheckout(true);
    }
    //navigate('/medineer/SignUp', { state: { series } });

  }

  const handleCloseModal = (series) => {
    refetch();
    setShowCheckout(false);
    //navigate('/medineer/SignUp', { state: { series } });

  }
  console.log(courses, "courselist")
  console.log(typeof (courses), "courselist")
  const toggleButtonStyles = (selected) => ({
    fontSize: '13px',
    fontFamily: 'Poppins',
    borderRadius: selected ? '87px' : '0',
    padding: '8px 11px',
    // fontWeight: selected ? 'bold' : 'normal',
    textTransform: 'capitalize',
    border: 'none',
    backgroundColor: selected ? "#fff" : "transparent",
    color: selected
      ? "#012248"    //theme.palette.heading.main
      : "#a0a0a0",
    cursor: 'pointer',
    boxShadow: selected ? '0 2px 2px 0 rgba(0, 0, 0, 0.1)' : '',
    transition: 'background-color 0.3s ease, color 0.3s ease',
    '&:hover': {
      backgroundColor: theme.palette.heading.main,
      color: theme.palette.drawerBackground.main,
      transform: 'scale(1.05)',
    },
  });

  const toggleGroupStyles = {
    display: 'inline-flex',
    borderRadius: '87px',
    borderColor: "black",
    padding: '5px',
    marginRight: '16px',
    marginBottom: '10px',
    backgroundColor: '#f2e7e7',
    boxShadow: 'inset 0 1px 2px 0 rgba(0, 0, 0, 0.1)'
  };
  const bestCoupen = (course) => {
    const availableCoupons = course?.coupons?.$values || [];
    const bestCoupon = availableCoupons?.length
      ? availableCoupons.reduce((prev, curr) =>
        (curr?.discountPercentage || 0) > (prev?.discountPercentage || 0) ? curr : prev
      )
      : null;
    return bestCoupon;
  }
  return (
    <div style={{ width: 'max' }}>
      <GridContainer style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <GridItem xs={12} sm={12} md={9} lg={9} style={{ padding: '0px !important' }}>
          <h4 className={styles.cardPageTitle} style={{ color: theme.palette.heading.main }}>
            {isSubscribed === true ?
              '' :   //t('assignedTestSeries') :
              <span className={styles.ExploreOurTestSeries}>
                <span className={styles.ExploreourTestSeriesstyle1}>Explore our Test Series —</span>
                <span className={styles.ExploreourTestSeriesstyle2}></span>
                an essential subscription for your success.
              </span>
            }
          </h4>
        </GridItem>
        {/* Toggle Button Group */}
        <GridItem xs={12} sm={12} md={2} lg={2}>
          {testSeriesStatus === "ALL" &&
            <ToggleButtonGroup
              value={isSubscribed ? "subscribe" : "unsubscribe"}
              exclusive
              onChange={handleToggle}
              aria-label="Subscription Toggle"
              style={toggleGroupStyles}
            >
              <ToggleButton value="subscribe" disabled={isLoading || loadingState} aria-label="Subscribe" style={toggleButtonStyles(isSubscribed)} >
                {'subscribed'}
              </ToggleButton>
              <ToggleButton value="unsubscribe" disabled={isLoading || loadingState} aria-label="Unsubscribe" style={toggleButtonStyles(!isSubscribed)} >
                {'Explore'}
              </ToggleButton>
            </ToggleButtonGroup>
          }
        </GridItem>
      </GridContainer>

      {selectedSeries ? (
        <TestSeriesDetails testSerieses={selectedSeries} onBack={() => setSelectedSeries(null)} />
      )
        : ((isLoading || loadingState) ?
          <Box style={{ color: theme.palette.heading.main }}>
            <CircularProgress style={{ color: theme.palette.heading.main }} />
            <h4 >{t('loading')}</h4>
          </Box>
          // <CircularProgress style={{ color: theme.palette.heading.main }} /> 
          :
          isSubscribed === true ? (
            <GridContainer>
              {
                courses && courses.length > 0 ? Object.values(courses).map((i, x) => (
                  <GridItem xs={12} sm={6} md={6} lg={4}>
                    <TestSeriesCardSubscribed
                      courseName={courses[x].courseName}
                      trailCourse={trailCourseData && (trailCourseData?.resourceId === courses[x]?.courseId) ? true : null}
                      trailEndDate={trailCourseData && (trailCourseData?.resourceId === courses[x]?.courseId) ? trailCourseData?.endDate : null}
                      objective={courses[x].objective}
                      targetAudience={courses[x].targetAudience}
                      onEnroll={() => onEnroll(courses[x])}
                      subscriptionstatus={courses[x]?.userSubscriptionStatus || null}
                      price={courses[x]?.price || 0}
                      image={courses[x].image}
                      description={courses[x].description}
                      courseId={courses[x].courseId}
                      code={courses[x].code}
                      courseTestStatusObj={courses[x].courseTestStatusObj}
                    />
                  </GridItem>
                )) :
                  <GridItem xs={12} sm={6} md={6} lg={4}>
                    <TestSeriesCardSubscribed
                      courseName={t('testseriesnotfound')}
                      // objective={courses[x].objective}
                      image={'record-not-found.png'}
                    // description={courses[x].description}
                    // courseId={courses[x].courseId}
                    // code={courses[x].code}
                    // courseTestStatusObj={courses[x].courseTestStatusObj}
                    />
                  </GridItem>
              }
              {
                showCheckout && <MedineerLogin course={courseDetails} closeModal={handleCloseModal} />

              }
            </GridContainer>
          )
            : (
              <GridContainer spacing={0.5}>
                {providerId == configUrl.MediNeerProviderId ? <Grid item xs='auto' sm='auto' md={5} lg={4} sx={{ paddingInline: '0 !important' }}>
                  <OwnTestCreationCard
                    image={'/TS_CPCard4.PNG'}
                    cardDescription={
                      <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                        {cardTemplateDescriptions && cardTemplateDescriptions.pickYourTestCardCardBulletPoints?.map((point, idx) => (
                          <li key={idx}><span style={{ marginRight: '8px', color: 'green' }}>✓</span>{point}</li>
                        ))}
                      </ul>
                    }
                  />
                </Grid> : null}
                {
                  courses && courses.length > 0 ? Object.values(courses).map((i, x) => {
                    // const cardDescription = cardTemplateDescriptions !== null ? cardTemplateDescriptions.TestSeries[i.courseId]?.TSBulletsPoints || cardTemplateDescriptions.TestSeries[3]?.TSBulletsPoints : 'not found';
                    // Derive the type
                    const seriesType = i.Type ? i.Type : "TestSeries";

                    // Match by ID + Type
                    const cardData = cardTemplateDescriptions.Cards.find(
                      card => card.ID === i.courseId && card.Type === seriesType
                    );
                    // const cardData = cardTemplateDescriptions.Cards.find(card => card.ID === i.courseId);
                    if (!cardData?.isActive) return null; //display only active courses
                    const cardDescription = cardData
                      ? cardData.CardBulletPoints
                      : cardTemplateDescriptions.Cards[0]?.CardBulletPoints || ["No details available"];

                    return (
                      <Grid item xs='auto' sm='auto' md={5} lg={4} sx={{ paddingInline: '0 !important' }}>

                        <TestSeriesCardUnsubscribed
                          title={courses[x].courseName}
                          description={courses[x]?.description}
                          image={courses[x].image ?? '/Gemini_image_not_available.jpg'}
                          bulletPoints={courses[x]?.bulletPoints}
                          price={courses[x]?.price || 0}
                          onLearnMore={() => handleLearnMore(courses[x], cardData)}
                          onEnroll={() => onEnroll(courses[x])}
                          bestCoupen={bestCoupen(courses[x])?.discountPercentage}
                          discountAmmt={cardData?.originalPrice}
                          testsCount={courses[x]?.testCount || 0}
                          //duration={series.duration}
                          courseId={courses[x].courseId}
                          isHideStudentIcon={true}
                          TagOnCard={cardData ? cardData.TagOnCard : ''}
                          SubjectTagOnCard={cardData ? cardData.SubjectTagOnCard : ''}
                          FreeCPTag={cardData ? cardData.FreeCPTag : ''}
                          cardDescription={
                            <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                              {cardDescription && cardDescription.map((point, idx) => (
                                <li key={idx}><span style={{ marginRight: '8px', color: 'green' }}>✓</span>{point}</li>
                              ))}
                            </ul>
                          }
                          fontSize={12}
                        />

                      </Grid>
                    )
                  }
                  ) :
                    <GridItem xs={12} sm={6} md={6} lg={4}>
                      <TestSeriesCardSubscribed
                        courseName={t('testseriesnotfound')}
                        // objective={courses[x].objective}
                        image={'record-not-found.png'}
                      // description={courses[x].description}
                      // courseId={courses[x].courseId}
                      // code={courses[x].code}
                      // courseTestStatusObj={courses[x].courseTestStatusObj}
                      />
                    </GridItem>
                }
                {
                  showCheckout && <MedineerLogin course={courseDetails} closeModal={handleCloseModal} />

                }
              </GridContainer>
            )
        )
      }

    </div>
  );
}